import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { ifDefined } from "lit/directives/if-defined.js";
import { baiduMapsClientKey } from "../../utils";

export default {
    title: "Components/Location Map",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-location-map",
    args: {
        clientKey: "gme-trumpfgmbhcokg",
        formSelector: undefined,
        mapProvider: "google",
        noResultsCodeSelector: undefined,
        routeLinkSelector: ".ux-iws-location-map__route-link a",
        type: "location-details",
        isSourceCode: false,
    },
    argTypes: {
        clientKey: { control: "text" },
        formSelector: { control: "text" },
        noResultsCodeSelector: { control: "text" },
        routeLinkSelector: { control: "text" },
        mapProvider: { control: "radio", options: ["google", "baidu"] },
        type: {
            control: "radio",
            options: ["country-locations", "dealer-search", "location-details"],
        },
    },
};

const LocationDetailsTemplate = ({
    clientKey,
    type,
    routeLinkSelector,
    noResultsCodeSelector,
    mapProvider,
    formSelector,
}) => {
    return html`
        <ux-iws-location-map
            client-key="${ifDefined(clientKey)}"
            map-provider="${mapProvider}"
            type="${type}"
            route-link-selector="${ifDefined(routeLinkSelector)}"
            form-selector="${ifDefined(formSelector)}"
            no-results-code-selector="${ifDefined(noResultsCodeSelector)}"
        >
            <script type="application/json" slot="config">
                {
                    "lat": 48.819064,
                    "lng": 9.069743,
                    "icon": "./mock-assets/images/marker.png"
                }
            </script>
            <div slot="cookie-notice">${cookieText()}</div>
            <div slot="privacy-notice">${privacyText()}</div>
            <div slot="location-details">
                <h2 class="ux-text-headline ux-text-headline--small">
                    TRUMPF GmbH + Co. KG
                </h2>
                <div class="ux-text-normal">
                    <p>
                        Johann-Maus-Straße 2 <br />
                        71254 Ditzingen <br />
                        Deutschland
                    </p>
                    <p>
                        <a class="ux-text-link" href="#"
                            >Tel.: +49-7156-303-0</a
                        >
                        <a class="ux-text-link" href="#"
                            >Fax.: +49-7156-303-930309</a
                        >
                        <a class="ux-text-link" href="#">info@de.trumpf.com</a>
                    </p>
                </div>
                <div class="ux-u-mt-xxs ux-iws-location-map__route-link">
                    <a href="javascript:void(0)" class="btn"> Route planner </a>
                </div>
            </div>
        </ux-iws-location-map>
    `;
};

const cookieText = () => {
    return html`
        <ux-icon name="circle-info" weight="light" size-s="60"></ux-icon>
        <div class="ux-text-headline ux-text-headline--medium ux-u-mt-xxs">
            You have not accepted the cookies
        </div>
        <div class="ux-text-normal ux-text-normal--light-gray">
            <p>
                Accept them now!
                <a href="#" data-ux-cookie-layer="settings"
                    >Open cookie settings</a
                >
            </p>
        </div>
    `;
};

const privacyText = () => {
    return html`
        <ux-icon name="circle-info" weight="light" size-s="60"></ux-icon>
        <div class="ux-text-headline ux-text-headline--medium ux-u-mt-xxs">
            You have not accepted the Privacy Policy
        </div>
        <div class="ux-text-normal ux-text-normal--light-gray">
            <p>
                Accept them now!
                <a href="#" data-ux-privacy-layer="settings"
                    >Open privacy settings</a
                >
            </p>
        </div>
    `;
};

export const Default = LocationDetailsTemplate.bind({});

export const Baidu = LocationDetailsTemplate.bind({});
Baidu.args = {
    mapProvider: "baidu",
    clientKey: baiduMapsClientKey,
};
